import React from 'react';
import styled from 'styled-components';
import { Box, Grid, GridProps } from '@material-ui/core';

export const FullHeightBox = styled(Box)`
        min-height: 100%;
`;

export const ListContainer = styled(({ children, ...other }: Omit<GridProps, 'item'>) => (
    <Grid item {...other}>{children}</Grid>
))`
        ${({ theme }) => `
            padding: ${theme.spacing(3)}px;
            width: 100%;
            ${theme.breakpoints.up('md')} {
                width: calc(100% - ${theme.spacing(36)}px);
            }
        `}
`;

export const SidebarContainer = styled(({ children, ...other }: Omit<GridProps, 'container' | 'item'>) => (
    <Grid {...other}>{children}</Grid>
))`
        ${({ theme }) => `
            width: ${theme.spacing(33)}px;
            margin-right: ${theme.spacing(3)}px;

            ${theme.breakpoints.down('sm')} {
                width: 100%;
                padding: ${theme.spacing(3)}px;
                margin-right: 0px;
            }
        `}
`;
